import { makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

const canceledByPreceptorStyles = makeStyles(theme => createStyles({
  block: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    backgroundColor: theme.palette.colors.lightOrange,
    borderTopLeftRadius: theme.spacing(1),
    borderBottomLeftRadius: theme.spacing(1),
    minWidth: 230,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'max-content',
    },
  },
  cancelByPreceptor: {
    color: theme.palette.colors.red,
  },
  iconCancel: {
    marginRight: theme.spacing(1),
    color: theme.palette.colors.red,
  },
}));

export default canceledByPreceptorStyles;
